import styled from 'styled-components';
import { Breakpoints } from '../../../styled/constants';
import { globalSystemColors } from '../../../styled/theme/constants';
import { FlexBetween, FlexColumn } from '../../../styled/common';
import LazyImage from '../../HOC/lazyImage';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.background.primary};
  @media (min-width: ${Breakpoints.desktop}px) {
    padding: 0 80px;
  }
`;

export const Container = styled.div`
  max-width: ${Breakpoints.desktop}px;
  margin: 0 auto;
  position: relative;
`;

export const Content = styled(FlexColumn)`
  padding: 90px 0 100px;

  @media (min-width: ${Breakpoints.tablet}px) and (max-width: ${Breakpoints.desktop}px) {
    padding: 70px 40px 90px;
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    padding: 70px 15px 90px;
  }
`;

export const GridExpandable = styled.div<{ maxHeight: number | 'auto' }>`
  overflow: hidden;
  margin-top: 40px;
  transition: max-height 0.4s ease;
  max-height: ${({ maxHeight }) =>
    maxHeight === 'auto' ? 'none' : `${maxHeight}px`};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px 64px;

  @media (min-width: ${Breakpoints.tablet}px) and (max-width: ${Breakpoints.desktop}px) {
    gap: 35px 24px;
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }
`;

export const Card = styled(FlexColumn)`
  overflow: hidden;
  width: 100%;
  max-width: 608px;
  height: 456px;
  margin: 0 auto;

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    height: 300px;
  }
  @media (max-width: ${Breakpoints.tablet}px) {
    height: auto;
  }
`;

export const CardLink = styled.a`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  text-decoration: none;
`;

export const CardImageWrapper = styled.div`
  width: 100%;
  height: 390px;
  border-radius: 12px;
  overflow: hidden;
  flex-shrink: 0;

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    height: 235px;
  }
  @media (max-width: ${Breakpoints.tablet}px) {
    height: 254px;
  }
`;

export const Image = styled(LazyImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 12px;
`;

export const HoverOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 77.95%,
    rgba(0, 0, 0, 0.2) 100%
  );
  border-radius: 12px;
  opacity: 0;
  transition: opacity 0.3s ease;

  &:after {
    content: '';
    display: block;
    position: absolute;
    right: 20px;
    bottom: 20px;
    width: 48px;
    height: 48px;
    background-color: ${globalSystemColors.white};
    background-image: url('/static/images/pasha/project-arrow.svg');
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 50%;
  }
`;

export const CardWrapper = styled.div`
  overflow: hidden;
  transition: background 0.3s ease;

  &:hover {
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 77.95%,
      rgba(0, 0, 0, 0.2) 100%
    );
  }

  &:hover ${HoverOverlay} {
    opacity: 1;
  }
`;

export const Info = styled.div`
  padding: 0 0 16px;
`;

export const CardTitle = styled.div`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 24px;
  margin-bottom: 5px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${Breakpoints.desktop}px) {
    font-size: 20px;
  }
`;

export const CardAddress = styled(FlexBetween)`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Badge = styled.span`
  font-size: 12px;
  padding: 1px 9px;
  background: ${({ theme }) => theme.colors.text.basic};
  color: ${({ theme }) => theme.colors.text.tertiary};
  border-radius: 80px;
`;

export const ShowMore = styled.button<{ $expanded?: boolean }>`
  font-size: 16px;
  margin: ${({ $expanded }) => ($expanded ? '40px auto 0' : '0 auto')};
  display: block;
  padding: 16px 30px;
  border-radius: 14px;
  border: 1px solid ${globalSystemColors.white};
  background: transparent;
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;
